import { render, staticRenderFns } from "./ImageFile1.vue?vue&type=template&id=a87fdba4"
import script from "./ImageFile1.vue?vue&type=script&lang=js"
export * from "./ImageFile1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports